import { useTheme } from '@mui/material';
import { Check, X } from 'lucide-react';
import { DICOMApprovalStatus } from '~/domain/dicom/dicomConstants';

export default function StructureReviewStatus({
    status,
}: {
    status: DICOMApprovalStatus;
}) {
    const { palette } = useTheme();
    switch (status) {
        case DICOMApprovalStatus.APPROVED:
            return <Check size="12px" color={palette.success.main} />;
        case DICOMApprovalStatus.REJECTED:
            return <X size="13px" color={palette.error.main} />;
        default:
            return null;
    }
}
